export const getParsedMessage = (error: any): string => {
  if (error?.name !== null && error?.name !== undefined) {
    if (error?.name === 'ResourceUnavailableRpcError') {
      return 'Connect request is already pending. Please cancel pending request and try again.'
    }
    if (error?.name === 'TransactionExecutionError') {
        return 'Transaction Rejected.'
    }
    if(error?.name === 'ConnectorNotFoundError'){
      return 'The required wallet was not found.'
    }
    if (error?.details?.includes('insufficient funds')) {
      return 'The total cost for this transaction (including additional costs) exceeds your available balance.'
    }
  }

  return error?.shortMessage ?? error?.message ?? 'Please try again'
}
